// hooks/useOutsideClick.ts
import { useEffect, useRef } from "react";

export const useOutsideClick = (
	ref: React.RefObject<HTMLElement>,
	callback: () => void,
	enabled = true,
) => {
	const cbRef = useRef(callback);

	// keep latest callback without resubscribing listeners
	useEffect(() => {
		cbRef.current = callback;
	}, [callback]);

	useEffect(() => {
		if (!enabled) return;

		const handler = (event: Event) => {
			const el = ref.current;
			const target = event.target as Node | null;

			if (!el || !target) return;

			// if click is outside
			if (!el.contains(target)) {
				cbRef.current();
			}
		};

		// pointerdown covers mouse + touch
		document.addEventListener("pointerdown", handler, true);

		return () => {
			document.removeEventListener("pointerdown", handler, true);
		};
	}, [ref, enabled]);
};
